import React, { useState, useEffect } from "react";
import axios from "axios";
import kldimg from "../src/assest/kidImg.jpg";
import verificationimg from "../src/assest/verified.gif";
import "./Form.css";

const RegistrationForm = () => {
  const isSubmitted = localStorage.getItem("formSubmitted");
  const initialFormData = isSubmitted
    ? {
        submissionSuccess: true,
        applicationNo:
          localStorage.getItem("applicationNo") ||
          `MVM-LKG-2026-27-${Math.floor(Math.random() * 1000) + 1251}`,
        submissionDate:
          localStorage.getItem("submissionDate") ||
          new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" }),
      }
    : {};

  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");
  const [isFormOpen] = useState(true);
  const [formPeriod] = useState({ startTimeDisplay: "", endTimeDisplay: "" });

//   useEffect(() => {
//     const fetchFields = async () => {
//       try {
//         const res = await axios.get("/api/form-fields");
//         let sorted = [...res.data].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

//         // AUTO-INSERT emailConfirm AFTER email
//         const emailIdx = sorted.findIndex(f => f.name === "email");
//         if (emailIdx !== -1 && !sorted.some(f => f.name === "emailConfirm")) {
//           const emailField = sorted[emailIdx];
//           const confirmField = {
//             _id: "auto-email-confirm",
//             label: "Re-enter your email id to confirm",
//             name: "emailConfirm",
//             fieldType: "email",
//             validations: {
//               required: emailField.validations.required,
//               pattern: emailField.validations.pattern || "^[^@]+@[^@]+\\.[^@]+$",
//             },
//             order: (emailField.order ?? 0) + 0.5,
//             helpText: "",
//             fieldCategory: emailField.fieldCategory,
//           };
//           sorted.splice(emailIdx + 1, 0, confirmField);
//         }

//         setFields(sorted);

//         const initialData = {};
//         const initialErrors = {};
//         sorted.forEach((field) => {
//           if (field.fieldType === "checkbox" && Array.isArray(field.options) && field.options.length > 0) {
//             initialData[field.name] = [];
//           } else if (field.fieldType === "checkbox") {
//             initialData[field.name] = false;
//           } else if (field.fieldType === "landline" || field.fieldType === "address") {
//             field.subFields?.forEach(sf => {
//               initialData[sf.name] = "";
//             });
//           } else {
//             initialData[field.name] = "";
//           }
//           initialErrors[field.name] = "";
//         });
//         if (!formData.submissionSuccess) {
//           setFormData((prev) => ({ ...prev, ...initialData }));
//           setErrors(initialErrors);
//         }
//       } catch (err) {
//         console.error("Error fetching form fields", err);
//       }
//     };

//     const fetchBanner = async () => {
//       try {
//         const res = await axios.get("/api/banner");
//         if (res.data.path) setBannerUrl(res.data.path);
//       } catch (err) {
//         console.error("Failed to fetch banner", err);
//       }
//     };

//     fetchFields();
//     fetchBanner();
//   }, []);

useEffect(() => {
  const fetchFields = async () => {
    try {
      const res = await axios.get("/api/form-fields");
      // 1. SORT BY INTEGER ORDER (backend now guarantees it)
      let sorted = [...res.data].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

      // 2. INSERT emailConfirm **AFTER** the email field (by array index)
      const emailIdx = sorted.findIndex(f => f.name === "email");
      if (emailIdx !== -1 && !sorted.some(f => f.name === "emailConfirm")) {
        const emailField = sorted[emailIdx];
        const confirmField = {
          _id: "auto-email-confirm",
          label: "Re-enter your email id to confirm",
          name: "emailConfirm",
          fieldType: "email",
          validations: {
            required: emailField.validations.required,
            pattern: emailField.validations.pattern || "^[^@]+@[^@]+\\.[^@]+$",
          },
          helpText: "",
          fieldCategory: emailField.fieldCategory,
          // **NO ORDER** – we keep the array order
        };
        sorted.splice(emailIdx + 1, 0, confirmField);
      }

      setFields(sorted);

      // ----- initialise formData / errors -----
      const initialData = {};
      const initialErrors = {};
      sorted.forEach((field) => {
        if (field.fieldType === "checkbox" && Array.isArray(field.options) && field.options.length > 0) {
          initialData[field.name] = [];
        } else if (field.fieldType === "checkbox") {
          initialData[field.name] = false;
        } else if (field.fieldType === "landline" || field.fieldType === "address") {
          field.subFields?.forEach(sf => { initialData[sf.name] = ""; });
        } else {
          initialData[field.name] = "";
        }
        initialErrors[field.name] = "";
      });

      if (!formData.submissionSuccess) {
        setFormData(prev => ({ ...prev, ...initialData }));
        setErrors(initialErrors);
      }
    } catch (err) {
      console.error("Error fetching form fields", err);
    }
  };

  const fetchBanner = async () => {
    try {
      const res = await axios.get("/api/banner");
      if (res.data.path) setBannerUrl(res.data.path);
    } catch (err) {
      console.error("Failed to fetch banner", err);
    }
  };

  fetchFields();
  fetchBanner();
}, []);

  // FIXED: validateField now accepts parentField for subfields
  const validateField = (field, value, parentField = null) => {
    const actualField = parentField || field;
    let err = "";
    const isEmpty = value === "" || value == null;

    if (actualField.validations?.required && isEmpty) {
      err = "This field is required";
    }

    if (field.name === "emailConfirm") {
      if (isEmpty) err = "Please re-enter email";
      else if (value !== formData.email) err = "Emails do not match";
      return err;
    }

    if ((field.fieldType === "tel" || field.name.includes("Area") || field.name.includes("Number")) && value) {
      const len = value.length;
      if (actualField.validations?.minLength && len < actualField.validations.minLength)
        err = `Min ${actualField.validations.minLength} digits`;
      if (actualField.validations?.maxLength && len > actualField.validations.maxLength)
        err = `Max ${actualField.validations.maxLength} digits`;
    }

    if (field.fieldType === "email" && value) {
      const regex = new RegExp(actualField.validations?.pattern || "^[^@]+@[^@]+\\.[^@]+$");
      if (!regex.test(value)) err = "Invalid email";
    }

    if (field.fieldType === "date" && value) {
      const v = new Date(value);
      if (actualField.validations?.minDate && v <= new Date(actualField.validations.minDate))
        err = "Date too early";
      if (actualField.validations?.maxDate && v >= new Date(actualField.validations.maxDate))
        err = "Date too late";
    }

    return err;
  };

  // FIXED: Find parent field for subfields
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Find parent field for landline/address subfields
    const parentField = fields.find(f =>
      (f.fieldType === 'landline' || f.fieldType === 'address') &&
      f.subFields?.some(sf => sf.name === name)
    );

    const field = parentField
      ? parentField.subFields.find(sf => sf.name === name) || parentField
      : fields.find(f => f.name === name);

    if (!field) return;

    if (field.fieldType === "checkbox" && Array.isArray(field.options)) {
      setFormData((prev) => {
        const existing = Array.isArray(prev[name]) ? [...prev[name]] : [];
        if (checked) {
          if (!existing.includes(value)) existing.push(value);
        } else {
          const idx = existing.indexOf(value);
          if (idx > -1) existing.splice(idx, 1);
        }
        return { ...prev, [name]: existing };
      });
      return;
    }

    if (field.fieldType === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
      setErrors((prev) => ({ ...prev, [name]: validateField(field, checked) }));
      return;
    }

    if (field.fieldType === "radio") {
      setFormData((prev) => ({ ...prev, [name]: value }));
      setErrors((prev) => ({ ...prev, [name]: validateField(field, value) }));
      return;
    }

    if (field.fieldType === "tel" || name.includes("Area") || name.includes("Number")) {
      const numeric = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: numeric }));
      setErrors((prev) => ({ ...prev, [name]: validateField(field, numeric, parentField) }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(field, value) }));
  };

  // FIXED: Validate subfields using parent validations
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    fields.forEach((field) => {
      if (field.fieldType === "landline" || field.fieldType === "address") {
        field.subFields?.forEach(sf => {
          const value = formData[sf.name] || "";
          newErrors[sf.name] = validateField(sf, value, field); // Pass parent field
        });
      } else {
        newErrors[field.name] = validateField(field, formData[field.name]);
      }
    });

    setErrors(newErrors);
    if (Object.values(newErrors).some((err) => err)) {
      setMessage("Please fix errors");
      return;
    }

    const landlineField = fields.find(f => f.fieldType === 'landline');
    let finalData = { ...formData };

    if (landlineField) {
      const area = formData[landlineField.subFields?.find(sf => sf.name.includes('Area'))?.name || 'landlineArea'] || '';
      const num = formData[landlineField.subFields?.find(sf => sf.name.includes('Number'))?.name || 'landlineNumber'] || '';
      finalData[landlineField.name] = area && num ? `(${area}) ${num}` : (area || num || '');
      landlineField.subFields?.forEach(sf => delete finalData[sf.name]);
    }

    // Remove address subfields from final data
    fields.filter(f => f.fieldType === "address").forEach(addrField => {
      addrField.subFields?.forEach(sf => delete finalData[sf.name]);
    });

    if (finalData.emailConfirm) {
      delete finalData.emailConfirm;
    }

    setMessage("Submitting...");
    try {
      const res = await axios.post("/api/submit", finalData);
      setMessage("");
      const applicationNo = `MVM-LKG-2026-27-${Math.floor(Math.random() * 1000) + 1251}`;
      const submissionDate = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
      setFormData((prev) => ({
        ...prev,
        submissionSuccess: true,
        applicationNo,
        submissionDate,
      }));
      localStorage.setItem("formSubmitted", "true");
      localStorage.setItem("applicationNo", applicationNo);
      localStorage.setItem("submissionDate", submissionDate);
    } catch (err) {
      setMessage("Failed to submit registration.");
      console.error(err);
    }
  };

 const handleRegisterAnother = () => {
    // 1. Remove the “submitted” flag
    localStorage.removeItem("formSubmitted");
    localStorage.removeItem("applicationNo");
    localStorage.removeItem("submissionDate");

    // 2. Reset the whole form to its *initial* empty state
    const initialData = {};
    const initialErrors = {};
    fields.forEach((field) => {
      if (
        field.fieldType === "checkbox" &&
        Array.isArray(field.options) &&
        field.options.length > 0
      ) {
        initialData[field.name] = [];
      } else if (field.fieldType === "checkbox") {
        initialData[field.name] = false;
      } else if (
        field.fieldType === "landline" ||
        field.fieldType === "address"
      ) {
        field.subFields?.forEach((sf) => {
          initialData[sf.name] = "";
        });
      } else {
        initialData[field.name] = "";
      }
      initialErrors[field.name] = "";
    });

    setFormData(initialData);
    setErrors(initialErrors);
    setMessage("");
  };
  const getAdjustedDate = (dateStr, adjustment) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (adjustment === "min") date.setDate(date.getDate() + 1);
    else date.setDate(date.getDate() - 1);
    return date.toISOString().split("T")[0];
  };

  // RENDER LANDLINE
  const renderLandline = (field) => {
    const areaField = field.subFields?.find(sf => sf.name.includes('Area')) || { name: `${field.name}Area`, label: 'Area Code', maxLength: 5 };
    const numField = field.subFields?.find(sf => sf.name.includes('Number')) || { name: `${field.name}Number`, label: 'Phone Number', maxLength: 8 };

    return (
      <div key={field._id} className="form-group landline-group">
        <label>
          {field.label} {field.validations.required && "*"}
        </label>
        <div className="landline-inputs">
          <input
            type="tel"
            name={areaField.name}
            placeholder={areaField.label}
            value={formData[areaField.name] || ""}
            onChange={handleChange}
            required={field.validations.required}
            className="form-control short"
            maxLength={areaField.maxLength}
          />
          <input
            type="tel"
            name={numField.name}
            placeholder={numField.label}
            value={formData[numField.name] || ""}
            onChange={handleChange}
            required={field.validations.required}
            className="form-control long"
            maxLength={numField.maxLength}
          />
        </div>
        <small className="help-text">Please do not prefix any number like '0' or '+91'</small>
        {(errors[areaField.name] || errors[numField.name]) && (
          <small className="error-msg">
            {errors[areaField.name] || errors[numField.name]}
          </small>
        )}
      </div>
    );
  };

  // RENDER ADDRESS (5 SUBFIELDS)
  const renderAddress = (field) => {
    const subFields = field.subFields || [];
    return (
      <div key={field._id} className="form-group address-group">
        <label>
          {field.label} {field.validations.required && "*"}
        </label>
        {subFields.map((sf, idx) => (
          <div key={sf.name} style={{ marginBottom: "8px" }}>
            <input
              type="text"
              name={sf.name}
              placeholder={sf.label}
              value={formData[sf.name] || ""}
              onChange={handleChange}
              required={field.validations.required}
              className="form-control"
              maxLength={sf.maxLength}
            />
            {errors[sf.name] && <small className="error-msg">{errors[sf.name]}</small>}
          </div>
        ))}
      </div>
    );
  };

  // RENDER EMAIL + CONFIRM
  const renderEmailGroup = () => {
    const emailField = fields.find((f) => f.name === "email");
    if (!emailField) return null;

    return (
      <div className="form-group">
        <label>{emailField.label} {emailField.validations.required && "*"}</label>
        <input
          type="email"
          name="email"
          value={formData.email || ""}
          onChange={handleChange}
          required={emailField.validations.required}
          className="form-control"
        />
        {errors.email && <small className="error-msg">{errors.email}</small>}

        <label style={{ marginTop: "10px" }}>
          Re-enter your email id to confirm {emailField.validations.required && "*"}
        </label>
        <input
          type="email"
          name="emailConfirm"
          value={formData.emailConfirm || ""}
          onChange={handleChange}
          required={emailField.validations.required}
          className="form-control"
          style={{ border: errors.emailConfirm ? "1px solid red" : "" }}
        />
        {errors.emailConfirm && <small className="error-msg">{errors.emailConfirm}</small>}
      </div>
    );
  };

  // RENDER INCOME
  const renderIncome = (field) => {
    return (
      <div className="form-group income-group">
        <label>{field.label} *</label>
        <div className="input-with-prefix">
          <span className="prefix">INR</span>
          <input
            type="tel"
            name={field.name}
            value={formData[field.name] || ""}
            onChange={handleChange}
            required={field.validations.required}
            className="form-control"
            placeholder="0"
          />
        </div>
        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
      </div>
    );
  };

  // RENDER ANY OTHER FIELD (NO DUPLICATES)
  const renderField = (field) => {
    if (field.fieldType === "landline" || field.fieldType === "address") return null;
    if (field.name === "email" || field.name === "emailConfirm") return null;
    if (field.name.endsWith("Income")) return renderIncome(field);

    const commonProps = {
      name: field.name,
      onChange: handleChange,
      required: field.validations.required,
      className: "form-control",
    };

    switch (field.fieldType) {
      case "text":
      case "tel":
      case "email":
        return <input type={field.fieldType} value={formData[field.name] || ""} {...commonProps} />;
      case "textarea":
        return <textarea value={formData[field.name] || ""} {...commonProps} />;
      case "date":
        return (
          <input
            type="date"
            value={formData[field.name] || ""}
            {...commonProps}
            min={getAdjustedDate(field.validations.minDate, "min")}
            max={getAdjustedDate(field.validations.maxDate, "max")}
          />
        );
      case "select":
        return (
          <select value={formData[field.name] || ""} {...commonProps}>
            <option value="">--Please choose an option--</option>
            {field.options?.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        );
      case "radio":
        return (
          <div className="radio-group">
            {field.options?.map((opt) => (
              <label key={opt} className="radio-label">
                <input
                  type="radio"
                  name={field.name}
                  value={opt}
                  checked={formData[field.name] === opt}
                  onChange={handleChange}
                /> {opt}
              </label>
            ))}
          </div>
        );
      case "checkbox":
        if (field.options?.length > 0) {
          return (
            <div className="checkbox-group">
              {field.options.map((opt) => (
                <label key={opt} className="checkbox-label">
                  <input
                    type="checkbox"
                    name={field.name}
                    value={opt}
                    checked={formData[field.name]?.includes(opt)}
                    onChange={handleChange}
                  /> {opt}
                </label>
              ))}
            </div>
          );
        } else {
          return (
            <label className="checkbox-label">
              <input
                type="checkbox"
                name={field.name}
                checked={!!formData[field.name]}
                onChange={handleChange}
              /> {field.label}
            </label>
          );
        }
      default:
        return null;
    }
  };

  const groupFields = () => {
  const groups = {
    application: [],
    communication: [],
    other: [],
    fatheroccupation: [],
    motheroccupation: [],
  };

  // `fields` is already sorted by order + emailConfirm inserted
  fields.forEach(field => {
    const cat = field.fieldType === "address" ? field.fieldCategory : (field.fieldCategory || 'other');
    if (groups[cat]) groups[cat].push(field);
  });

  return groups;
};
  const grouped = groupFields();

  return (
    <div className="registration-form">
      {bannerUrl && <img src={bannerUrl} alt="School Banner" className="form-banner" />}

      {!formData.submissionSuccess ? (
        fields.length === 0 ? (
          <p>Loading form...</p>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* APPLICANT DETAILS */}
            {grouped.application.length > 0 && (
              <div className="section">
                <h3>Applicant Details</h3>
                {grouped.application.map((field) => (
                  <div key={field._id || field.name}>
                    {field.fieldType === "landline" && renderLandline(field)}
                    {field.fieldType === "address" && renderAddress(field)}
                    {field.name === "email" && renderEmailGroup()}
                    {field.fieldType !== "landline" && field.fieldType !== "address" && field.name !== "email" && field.name !== "emailConfirm" && (
                      <div className="form-group">
                        <label>
                          {field.label} {field.validations.required && "*"}
                        </label>
                        {renderField(field)}
                        {field.helpText && <small className="help-text">{field.helpText}</small>}
                        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* COMMUNICATION DETAILS */}
            {grouped.communication.length > 0 && (
              <div className="section">
                <h3>Communication Details</h3>
                {grouped.communication.map((field) => (
                  <div key={field._id || field.name}>
                    {field.fieldType === "landline" && renderLandline(field)}
                    {field.fieldType === "address" && renderAddress(field)}
                    {field.name === "email" && renderEmailGroup()}
                    {field.fieldType !== "landline" && field.fieldType !== "address" && field.name !== "email" && field.name !== "emailConfirm" && (
                      <div className="form-group">
                        <label>
                          {field.label} {field.validations.required && "*"}
                        </label>
                        {renderField(field)}
                        {field.helpText && <small className="help-text">{field.helpText}</small>}
                        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* OTHER DETAILS */}
            {grouped.other.length > 0 && (
              <div className="section">
                <h3>Other Details</h3>
                {grouped.other.map((field) => (
                  <div key={field._id || field.name}>
                    {field.fieldType === "landline" && renderLandline(field)}
                    {field.fieldType === "address" && renderAddress(field)}
                    {field.fieldType !== "landline" && field.fieldType !== "address" && (
                      <div className="form-group">
                        <label>
                          {field.label} {field.validations.required && "*"}
                        </label>
                        {renderField(field)}
                        {field.helpText && <small className="help-text">{field.helpText}</small>}
                        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* FATHER'S OCCUPATION */}
            {grouped.fatheroccupation.length > 0 && (
              <div className="section">
                <h3>Father's Occupation Details</h3>
                {grouped.fatheroccupation.map((field) => (
                  <div key={field._id || field.name}>
                    {field.fieldType === "landline" && renderLandline(field)}
                    {field.fieldType === "address" && renderAddress(field)}
                    {field.fieldType !== "landline" && field.fieldType !== "address" && (
                      <div className="form-group">
                        <label>
                          {field.label} {field.validations.required && "*"}
                        </label>
                        {renderField(field)}
                        {field.helpText && <small className="help-text">{field.helpText}</small>}
                        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* MOTHER'S OCCUPATION */}
            {grouped.motheroccupation.length > 0 && (
              <div className="section">
                <h3>Mother's Occupation Details</h3>
                {grouped.motheroccupation.map((field) => (
                  <div key={field._id || field.name}>
                    {field.fieldType === "landline" && renderLandline(field)}
                    {field.fieldType === "address" && renderAddress(field)}
                    {field.fieldType !== "landline" && field.fieldType !== "address" && (
                      <div className="form-group">
                        <label>
                          {field.label} {field.validations.required && "*"}
                        </label>
                        {renderField(field)}
                        {field.helpText && <small className="help-text">{field.helpText}</small>}
                        {errors[field.name] && <small className="error-msg">{errors[field.name]}</small>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* DECLARATION */}
            <div className="section">
              <h3>Declaration</h3>
<p>I / We hereby certify that the above information provided by me / us is correct and I / We understand that if the
information is found to be incorrect or false, the application shall be automatically rejected from registration process
without any correspondence in this regard. I / We understand that short listing of this registration form does not
guarantee admission to my ward. I / We accept the process of admission undertaken by the school and I / We will
abide by the decision taken by the school authorities.
</p>
              <div style={{ display: "flex", justifyContent: "space-between", margin: "52px 0px" }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ borderTop: "1px solid #000", width: "200px", margin: "0 auto 5px" }}></div>
                  <small>Signature of the Father</small>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ borderTop: "1px solid #000", width: "200px", margin: "0 auto 5px" }}></div>
                  <small>Signature of the Mother</small>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <strong>Name of Father:</strong> {formData.fatherName || "________________"}
                </div>
                <div>
                  <strong>Name of Mother:</strong> {formData.motherName || "________________"}
                </div>
              </div>
              <div style={{ textAlign: "right", marginTop: "30px" }}>
                <strong>Date and Time of Submission:</strong> {new Date().toLocaleDateString("en-IN")}
              </div>
            </div>

            <button type="submit" className="submit-btn">Submit</button>
            {message && <p className="form-msg">{message}</p>}
          </form>
        )
      ) : (
         <div className="success-acknowledgment">
          <div style={{ textAlign: "center", fontSize: "48px" }}>
            <img
              src={verificationimg}
              alt="Verification"
              className="verification-img"
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              <strong>Application No:</strong> {formData.applicationNo}
            </p>
            <p>
              <strong>Date:</strong> {formData.submissionDate}
            </p>
          </div>

          {/* ---- NEW BUTTON ---- */}
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <button
              type="button"
              className="submit-btn"
              onClick={handleRegisterAnother}
              style={{ background: "#28a745", color: "#fff" }}
            >
              Register Another Child
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationForm;

